import { useState } from "react";
import { Card, CardBody, Col, Toast, ToastBody, ToastHeader } from "reactstrap";
import { DefaultToastTitle } from "../../../constants";
import { ColorsSchemeSubTitle } from "../../../data/bonusUi/Toasts";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const DefaultToast = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DefaultToastTitle} span={ColorsSchemeSubTitle} />
        <CardBody className="toast-rtl">
          <Toast isOpen={open}>
            <ToastHeader className="toast-img" toggle={() => setOpen(false)}>
              <Image className="rounded me-2" src={dynamicImage(`dashboard-8/profile.png`)} alt="profile" />
              {"Berlin Theme"}
              <small>{"10 min ago"}</small>
            </ToastHeader>
            <ToastBody className="toast-dark">
              <strong className="txt-success">{"Well done!"}</strong> {"You successfully read this important message."}
            </ToastBody>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DefaultToast;
